/**
 * Canonical list of project types used for Job records.
 * All consumers (backend + frontend) should import from this shared module
 * to guarantee a consistent union type.
 */
export const PROJECT_TYPES = [
  "Adjustment",
  "Admin Fee",
  "Cabinets & Vanities",
  "Carpet",
  "Carpet Cleaning",
  "Ceilings & Cover",
  "Change Order",
  "Cleaning",
  "Concrete & Masonry",
  "Consulting",
  "Credit",
  "Demolition",
  "Discount",
  "Door & Trim",
  "Electrical",
  "Emergency Service",
  "Equipment Rental",
  "Excavation",
  "Exterior Trim & Deck",
  "Exterior Wall & Trim",
  "Flooring",
  "Follow Up",
  "Framing",
  "Furniture Move / Put Back",
  "General",
  "Handling Fee",
  "Hauling",
  "HVAC (Heating/Cooling)",
  "Inspection (Building / Site)",
  "Insulation",
  "Interior Walls",
  "Labor",
  "Landscaping & Paving",
  "Late Fee",
  "Leak Detection",
  "Material",
  "Millwork & Trim",
  "No Show Fee",
  "Paint",
  "Parts",
  "Plans and Permits",
  "Plumbing",
  "Professional Services",
  "Reimbursement",
  "Repair & Restoration",
  "Roof",
  "Sales",
  "Service Call / Trip Charge",
  "Siding",
  "Specialty",
  "Stucco / Mortar",
  "Supervision",
  "Surface Protection & Dust Containment",
  "Tile & Countertop",
  "Time & Material",
  "Uncollectable Debt",
  "Water Test",
  "Window & Trim",
  "Other",
] as const;

export type ProjectType = (typeof PROJECT_TYPES)[number];
